export const NFTCONTRACT = "0xacFe3CeFac34845952EaECD1a184b8c0BD70A0FD";
export const STAKINGCONTRACT = "0x1DBEd099563c586C398016f11823385e8d089A80";
export const sonarCashApi = "https://testnet.sonar.cash/api";
export const nftpng = "https://raw.githubusercontent.com/wenlambotoken/NFTSWenLambo/main/png/";
export const MASTERCHEFCONTRACT = '0xa782566120CE61fA052c92dc7f744973e19D4dD9'; //modify
export const LPCONTRACT = '0xC6c4d0531313d5B95169F15F0441F96784835054'; //modify 
export const infinite = '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff';
export const RLAMBOADDRESS = '0x99142F54c0D91A57370a535B8b4F3ac7137DE944'; 
export const LAMBOADDRESS =  '0x0E36C351ff40183435C9Bd1D17bfb1F3548f1963';

// mainnet token contract: 0x99142F54c0D91A57370a535B8b4F3ac7137DE944;
    
// rate: 1 rlam = 0.001 lambo 